// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lg-multi-filter__frame {
  height: auto;
  min-height: 36px;
}
.lg-multi-filter__frame--invalid {
  border-color: #eb2844 !important;
}
.lg-multi-filter__frame .lg-multi-filter__option-list__item {
  cursor: default;
  display: flex;
  align-items: center;
}
.lg-multi-filter__frame .lg-multi-filter__option-list__item lg-icon {
  cursor: pointer;
}
.lg-multi-filter__frame .lg-multi-filter__option-list__item--disabled lg-icon {
  cursor: default;
}

form {
  flex: 1 1 auto;
  line-height: 24px;
}
form input {
  width: 100%;
  border: none;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/tag-input/tag-input.component.scss"],"names":[],"mappings":"AAEA;EACI,YAAA;EACA,gBAAA;AADJ;AAGI;EACI,gCAAA;AADR;AAII;EACI,eAAA;EACA,aAAA;EACA,mBAAA;AAFR;AAGQ;EACI,eAAA;AADZ;AAIY;EACI,eAAA;AAFhB;;AAQA;EACI,cAAA;EACA,iBAAA;AALJ;AAMI;EACI,WAAA;EACA,YAAA;AAJR","sourcesContent":["@import \"definitions\";\n\n.lg-multi-filter__frame {\n    height: auto;\n    min-height: 36px;\n\n    &--invalid {\n        border-color: $error-color !important;\n    }\n\n    .lg-multi-filter__option-list__item {\n        cursor: default;\n        display: flex;\n        align-items: center;\n        lg-icon {\n            cursor: pointer;\n        }\n        &--disabled {\n            lg-icon {\n                cursor: default;\n            }\n        }\n    }\n}\n\nform {\n    flex: 1 1 auto;\n    line-height: 24px;\n    input {\n        width: 100%;\n        border: none;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
